import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="hovercard"
export default class extends Controller {
  static targets = [ "card" ]
  static values = {
    cardId: String,
    url: String,
    loggedIn: Boolean
  }

  defaultTimeout = 250

  connect() {
    this.show();
  }

  show() {
    if (!this.loggedInValue) return;

    if (this.hasCardTarget) {
        this.unhide();
    } else {
      // wait 1 second
      setTimeout(() => {
        // is the mouse still hovering over cardTarget
        if (this.element.matches(":hover")) {
          fetch(this.urlValue)
            .then((r) => r.text())
            .then((html) => {
                // Remove anchor tags with href attributes from the HTML
              const fragment = document.createRange().createContextualFragment(html)
              // Remove elements with data-action="mouseenter->hovercard#show" attribute
              let elements = fragment.querySelectorAll('action-text-attachment')
              // Loop through each element and modify its innerHTML
              elements.forEach((el) => {
                // Get the current innerHTML of the element
                let htmlString = el.innerHTML;

                // Remove the data-action attribute from the string
                htmlString = htmlString.replace(/data-action="[^"]*"/g, '');

                // Set the modified HTML string back as the innerHTML of the element
                el.innerHTML = htmlString;
              })
              this.element.appendChild(fragment)
            })
        }
      }, this.defaultTimeout);
    }
  }

  unhide() {
    if (this.cardTarget.classList.contains("hidden")) {
      // wait 1 second
      setTimeout(() => {
        // is the mouse still hovering over cardTarget
        if (this.element.matches(":hover")) {
          this.cardTarget.classList.remove("hidden");
        }
      }, this.defaultTimeout);
    }
  }

  hide() {
    if (this.hasCardTarget) {
      this.cardTarget.classList.add("hidden");
    }
  }

  disconnect() {
    if (this.hasCardTarget) {
      this.cardTarget.remove();
    }
  }
}
